/** Strip AI metadata blocks (```json:meta ... ```) from streamed content */
export function stripMetadataBlock(content: string): string {
  let cleaned = content.replace(/```json:meta[\s\S]*?```/g, '')
  cleaned = cleaned.replace(/```json:meta[\s\S]*$/g, '')
  return cleaned.trim()
}
